// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  // 加載列表
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_SysSetting/Load',
      params,
    });
  },
  // 更新
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_SysSetting/Update',
      data,
    });
  },
};
